const SECONDS_PER_HOUR = 3600;
const SECONDS_PER_MINUTE = 60;

export const formatDurationSeconds = (totalSeconds: number): string => {
    const hours = Math.floor(totalSeconds / SECONDS_PER_HOUR);
    const minutes = Math.floor((totalSeconds % SECONDS_PER_HOUR) / SECONDS_PER_MINUTE);

    return hours > 0 ? `${hours}h ${minutes}m` : `${minutes}m`;
};
